import React from 'react';
import styled from 'styled-components';
import { Box, Button, Link, Text } from '@99designs/emu';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import PreviousReports from './PreviousReports';
import TwoColumnImageText from './TwoColumnImageText';
import { DWB21_Green } from './colors';

const Wrapper = styled.div`
    max-width: 1440px;
`;

const attributionList = [
    {
        author: 'šaška',
        profile: '/profiles/2173564',
        designCategoryBy: 'Illustrations by',
    },
    {
        author: 'smiDESIGN',
        profile: '/profiles/663841',
        designCategoryBy: 'Full report design by',
    },
    {
        author: 'Maryia Dziadziulia',
        profile: '/profiles/731215',
        designCategoryBy: 'Animation by',
    },
];

export default function About99designs() {
    return (
        <Wrapper>
            <TwoColumnImageText
                variations={['copy-first']}
                backgroundColor={DWB21_Green}
                heading="About 99designs by Vista"
                subHeading="Oh hey there!"
                mediaProps={{
                    fallbackImageUrl: publicImageUrl('design-without-borders/about-99d.gif'),
                    mediaAlign: 'center',
                    crop: false,
                    height: { extraLarge: '100%', large: '85%', normal: '65%', medium: '100%' },
                }}
                borderBottom={false}
                bottom={
                    <Box>
                        <Box marginBottom="2bu">
                            <Button
                                href="/"
                                openInNewTab={true}
                                width={['fill', 'auto', 'auto', 'auto']}
                                appearance="primary"
                                size="large"
                            >
                                Learn more
                            </Button>
                        </Box>
                        <Box display="flex" flexDirection="column">
                            {attributionList.map((attribute, index) => {
                                return (
                                    <Text fontFamily="attribution" italic={true} key={index}>
                                        {attribute.designCategoryBy} &nbsp;
                                        <Link href={attribute.profile} target="_blank">
                                            {attribute.author}
                                        </Link>
                                    </Text>
                                );
                            })}
                        </Box>
                    </Box>
                }
            >
                99designs by Vista is the global creative platform that makes it easy for clients
                and designers to work together online. Since 2008, our freelance community has
                brought more than one million creative projects to life for folks in all corners of
                the world. People are at the heart of what we do here. Which is why, each year, we
                survey thousands of freelancers and share their experiences, stories and industry
                insights through our Design Without Borders report. These are the voices that shape
                this diverse community.
            </TwoColumnImageText>
            <PreviousReports backgroundColor={DWB21_Green}></PreviousReports>
        </Wrapper>
    );
}
